import { http } from 'http';

export default {
  uploadDocument: ({ folder, docType, file }) =>
    http.post(`/actas/docs/${folder}/${docType}`, file, {
      headers: { 'content-type': 'multipart/form-data' }
    })
};
